import { Messages } from '../../../codegen/Localize';
import { Order } from '../../helpers/Order';
import { OrderKeys } from '../OrderKeys';
import { SortOptions } from './CommonSortOptions';
import { OptionsDictionary } from './SortOptionDefinitions';

export const extractRefreshSortOptions: OptionsDictionary = {
  'tasktype': {
    id: OrderKeys.type,
    getMenuItemDisplayValue: Messages.column_task_type,
    subSortOptions: {
      'asc': {
        id: 'type.asc',
        field: OrderKeys.type,
        getMenuItemDisplayValue: Messages.sortByAZ,
        ascending: true,
        toOrderClauseArray: () => [Order.asc(OrderKeys.type)]
      },
      'desc': {
        id: 'type.desc',
        field: OrderKeys.type,
        getMenuItemDisplayValue: Messages.sortByZA,
        ascending: false,
        toOrderClauseArray: () => [Order.desc(OrderKeys.type)]
      }
    }
  },
  'schedule' : SortOptions.schedule,
  'priority' : {
    id: OrderKeys.priority,
    getMenuItemDisplayValue: Messages.column_task_priority,
    subSortOptions: {
      'asc': {
        id: 'priority.asc',
        field: OrderKeys.priority,
        getMenuItemDisplayValue: Messages.sortByAZ,
        ascending: true,
        toOrderClauseArray: () => [Order.asc(OrderKeys.priority)]
      },
      'desc': {
        id: 'priority.desc',
        field: OrderKeys.priority,
        getMenuItemDisplayValue: Messages.sortByZA,
        ascending: false,
        toOrderClauseArray: () => [Order.desc(OrderKeys.priority)]
      }
    }
  },
  'lastRunAt' : SortOptions.lastRunAt,
  'runNextAt' : SortOptions.runNextAt
};
